<template>
  <div class="mt-6 text-sm">
    <loader v-if="campaigns === null" />
    <div v-else>
      <div class="flex justify-end mb-6">
        <button @click="newCampaignModalOpen = true" class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow">
          <i class="fas fa-plus-circle"></i> Create New Campaign
        </button>
      </div>

      <panel v-if="campaigns.data.length === 0" class="pt-6">
        <div>
          <i class="fas fa-info-circle"></i> No campaigns have been created for {{ selectedOffice.name }}.
        </div>
      </panel>
      <panel v-else class="pt-6">
        <div class="overflow-x-auto">
          <table class="table-auto text-center w-full">
            <thead class="uppercase text-xs">
              <tr class="whitespace-no-wrap">
                <th class="text-left p-2">Campaign Name</th>
                <th class="p-2">Frequency</th>
                <th class="p-2">Next Edition</th>
                <th class="p-2">Settings</th>
                <!-- <th class="p-2">Reports</th> -->
                <th class="p-2">Active</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campaign in campaigns.data" :key="campaign.id">
                <td class="text-left p-2">{{ campaign.name }}</td>
                <td class="p-2">{{ getFrequency(campaign.frequency_id) }}</td>
                <td class="p-2" v-if="campaign.deleted_at">-</td>
                <td class="p-2" v-else>{{ campaign.next_delivery_at | date(false) }}</td>
                <td class="p-2"><i class="fas fa-fw fa-cog hover:text-blue-dark cursor-pointer" @click="$emit('change-campaign', campaign.id)"></i></td>
                <!-- <td class="p-2"><i class="fas fa-fw fa-chart-bar hover:text-blue-dark cursor-pointer"></i></td> -->
                <td class="p-2"><i class="fas fa-fw" :class="campaign.deleted_at ? 'fa-times-circle text-red-dark' : 'fa-check-circle text-green-dark'"></i></td>
              </tr>
            </tbody>
          </table>

          <paginator :data="campaigns" @change="searchParams.page = $event"/>
        </div>
      </panel>

      <modal v-if="newCampaignModalOpen" @leave="newCampaignModalOpen = false" show-close-btn width="320px">
        <h2 class="font-bold text-sm mb-6">New Campaign</h2>

        <div class="mb-6">
          <label for="name">Enter campaign name:</label>
          <input type="text" id="name" v-model="newCampaignForm.name" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('name') }">
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('name')" v-text="errorBag.get('name')"></small>
        </div>

        <div class="mb-6">
          <p class="mb-3">Included offices:</p>
          <div v-for="office in offices" :key="office.id" class="mb-2">
            <input type="checkbox" :id="`office${office.id}`" :value="office.id" v-model="newCampaignForm.office_ids">
            <label :for="`office${office.id}`">{{ office.name }}</label>
          </div>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('office_ids')" v-text="errorBag.get('office_ids')"></small>
        </div>

        <loader v-if="saving" />
        <button v-else class="text-white py-2 px-6 text-sm bg-tertiary rounded shadow" @click="createCampaign">
          Create Campaign
        </button>
      </modal>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapActions, mapState } from 'vuex'
import ErrorBag from '@/ErrorBag'

export default {
  created () {
    this.getOffices()
    this.search()
  },
  data () {
    return {
      searchParams: {
        page: 1
      },
      campaigns: null,
      newCampaignModalOpen: false,
      newCampaignForm: {
        name: null,
        office_ids: []
      },
      errorBag: new ErrorBag(),
      saving: false,
      offices: []
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    search () {
      this.newCampaignForm.name = this.selectedOffice ? `${this.selectedOffice.name} - Property Focus` : null

      v2Api.get('ezine-campaigns', {
        params: {
          ...this.searchParams,
          client_id: this.selectedOffice.client_id
        }
      }).then((response) => {
        this.campaigns = response.data
      })
    },
    getOffices () {
      v2Api.get('office/with-locations', {
        params: {
          client_id: this.selectedOffice.client_id
        }
      }).then((response) => {
        this.offices = response.data.map((o) => {
          return {
            id: o.id,
            name: `${o.name} (${o.address_town})`
          }
        })

        this.newCampaignForm.office_ids = this.offices.length > 20 ? [] : this.offices.map((o) => o.id)
      })
    },
    fetchCampaign (id) {
      v2Api.get(`ezine-campaigns/${id}`).then((response) => {
        this.form = response.data
      })
    },
    createCampaign () {
      this.saving = true
      v2Api.post('/ezine-campaigns', {
        client_id: this.selectedOffice.client_id,
        ...this.newCampaignForm
      }).then((response) => {
        this.$emit('change-campaign', response.data.id)
      },
      (errors) => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-exclamation-triangle',
          title: 'Error',
          info: errors.response.data.message
        })
        this.errorBag.store(errors.response.data)
        this.saving = false
      })
    },
    getFrequency (id) {
      switch (id) {
        case 0: return 'Weekly'
        case 2: return 'Monthly'
        case 3: return 'Bimonthly'
        default: return 'Fortnightly'
      }
    }
  },
  watch: {
    selectedOffice () {
      this.search()
    }
  }
}
</script>
